export class RecoverPassController {
  constructor($scope, $modalInstance, $modal, UserService) {
    $scope.vm = this;
    this.scope = $scope;
    this.modal = $modal;
    this.UserService = UserService;

    this.scope.cancel = () => {
      $modalInstance.dismiss('cancel');
    };

    this.scope.sendMail = (email) => {
      $modalInstance.close(email);
    };
  }
}
